import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login, getMe, storePortalSession } from "../services/authApi";
import "../styles/ManufacturerLoginPage.css";

function ManufacturerLoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setSubmitting(true);

    try {
      const data = await login(email, password);

      if (!data || data.ok !== true || !data.token || !data.user) {
        setError("Invalid response from server.");
        setSubmitting(false);
        return;
      }

      // Store token first so apiClient can attach it
      storePortalSession({ token: data.token, user: data.user, permissions: [] });

      // Pull canonical role + permissions
      const me = await getMe(); // { ok, user, permissions }
      if (!me?.ok || !me?.user) throw new Error("me_failed");

      storePortalSession({ token: data.token, user: me.user, permissions: me.permissions || [] });

      const perms = Array.isArray(me.permissions) ? me.permissions : [];
      const role = me.user?.role;

      if (role === "manufacturer_admin") navigate("/portal/dashboard", { replace: true });
      else if (perms.includes("purchasing.po.read")) navigate("/portal/purchasing", { replace: true });
      else if (perms.includes("inventory.stock.levels.read")) navigate("/portal/inventory", { replace: true });
      else if (role === "org_admin") navigate("/portal/ops", { replace: true });
      else navigate("/portal/home", { replace: true });
    } catch (err) {
      console.error("[ManufacturerLoginPage] login error:", err);
      const msg =
        err?.response?.data?.error === "invalid_credentials"
          ? "Invalid email or password."
          : "Unable to sign in. Please try again.";
      setError(msg);
      setSubmitting(false);
    }
  }

  return (
    <section className="ucx-mfg-login-page">
      <div className="ucx-mfg-login-card">
        <div className="ucx-mfg-login-header">
          <h1 className="ucx-mfg-login-title">UNI-CODEX Manufacturer Portal</h1>
          <p className="ucx-mfg-login-subtitle">
            Sign in with your registered email to manage your UNI-CODEX identity.
          </p>
        </div>

        {error && <div className="ucx-mfg-login-error">{error}</div>}

        <form className="ucx-mfg-login-form" onSubmit={handleSubmit}>
          <div className="ucx-mfg-login-field">
            <label htmlFor="mfg-email">Email</label>
            <input
              id="mfg-email"
              type="email"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="ucx-mfg-login-field">
            <label htmlFor="mfg-password">Password</label>
            <input
              id="mfg-password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button
            type="submit"
            className="ucx-btn ucx-btn-primary ucx-mfg-login-submit"
            disabled={submitting}
          >
            {submitting ? "Signing in…" : "Sign in"}
          </button>

          <p className="ucx-mfg-login-footnote">
            If you were recently approved, use the temporary password provided to you.
          </p>
        </form>
      </div>
    </section>
  );
}

export default ManufacturerLoginPage;
